import ApiService from '@/services/api.service.js';

export const FileUploadService = {

    deleteFile: function(fileId) {
        return ApiService.delete('/application-files/' + fileId);
    },

    uploadFile: function(data) {
        return ApiService.customRequest({
            method: 'POST',
            url: 'application/files/' + data.applicationId,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            data: data.formData
        });
    },

    deleteEvaluationFile: function(fileId) {
        return ApiService.delete('/evaluation-files/' + fileId);
    },

    uploadEvaluationFile: function(data) {
        return ApiService.customRequest({
            method: 'POST',
            url: 'evaluation/files/' + data.evaluationId,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            data: data.formData
        });
    },

    uploadClarificationFile: function(data) {
        return ApiService.customRequest({
            method: 'POST',
            url: 'clarification/files/' + data.clarification_question_id,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            data: data.formData
        });
    },

    uploadMonitoringFiles: function(data) {
        return ApiService.customRequest({
            method: 'POST',
            url: 'monitoring/files/' + data.applicationId,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            data: data.formData
        });
    },

    deleteMonitoringFile: function(fileId) {
        return ApiService.delete('/monitoring/files/' + fileId);
    },

    uploadMonitoringReportFiles: function(data) {
        return ApiService.customRequest({
            method: 'POST',
            url: 'monitoring/report/files/' + data.reportId,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            data: data.formData
        });
    },

    deleteMonitoringReportFile: function(fileId) {
        return ApiService.delete('/monitoring/report/files/' + fileId);
    },

    groupDownload: function(payload) {
        return ApiService.customRequest({
            method: payload.method,
            url: payload.url, // 'monitoring/report/files/' + payload.reportId
            // index:payload.index
        });
    },

}

export default FileUploadService